import { useEffect, useRef } from "react";
import Navbar from "../common/navbar/navbar" ;

// Content Sections
import IntroSection from "./sections/intro-section";
import HowItWorksSection from "./sections/how-it-works-section";
import CompanySection from "./sections/company-section";
import PricingSection from "./sections/pricing-section";
import TestimonialSection from "./sections/testimonial-section";
import FreeAlertsSection from "./sections/free-alerts-section";
import FooterSection from "../common/footer/footer";
import { CHOOSE_PLAN_ROUTE } from "../../routes";

const Home = ({history}) => {

    // ref for each section (used in scrolling effect)
    let howItWorksSectionRef = useRef(null);
    let companySectionRef    = useRef(null);
    let pricingSectionRef    = useRef(null);
    let freeAlertsRef    = useRef(null);

    // style variables
    let navHeight = "7.25rem" ;

    // scrolls element into view
    const scrollElementToView = (element) => {
        const offsetPosition = window.pageYOffset + element.getBoundingClientRect().top - 64 ;
        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    }

    // wrapper function for getting element from ref and then scrolling it into view
    const scrollToSection = (ref) => {
        if(ref && ref.current ) {
            scrollElementToView(ref.current);
        }
        return true;
    }

    // checks if url has link to any section if any it scrolls to that section smoothly
    useEffect(()=>{
        if(window.location.href.indexOf("#") === -1) return
        let anchorId = window.location.href.slice(window.location.href.indexOf("#") + 1) ;
        let element = document.querySelector("#" + anchorId);
        if(element)
            scrollElementToView(element)
    },[])


    // links for top navbar
    const navLinks = [
        <h5 key="0" style={{cursor:"pointer"}} onClick={() => scrollToSection(howItWorksSectionRef)} className="my-0 mx-3 text-1">How it Works</h5>,
        <h5 key="1" style={{cursor:"pointer"}} onClick={() => scrollToSection(companySectionRef)}    className="my-0 mx-3 text-1">Company</h5>,
        <h5 key="2" style={{cursor:"pointer"}} onClick={() => scrollToSection(pricingSectionRef)}    className="my-0 mx-3 text-1">Pricing</h5>,
        <h5 key="3" style={{cursor:"pointer"}} onClick={() => history.push("/contact-us")}           className="my-0 mx-3 text-1">Contact Us</h5>,
    ];

    // links for sidebar
    const sidebarLinks = [
        <h5 key="0" style={{cursor:"pointer"}} onClick={() => scrollToSection(howItWorksSectionRef)} data-bs-dismiss="offcanvas" className="my-0 mx-3 text-1">How it Works</h5>,
        <h5 key="1" style={{cursor:"pointer"}} onClick={() => scrollToSection(companySectionRef)}    data-bs-dismiss="offcanvas" className="my-0 mx-3 text-1">Company</h5>,
        <h5 key="2" style={{cursor:"pointer"}} onClick={() => scrollToSection(pricingSectionRef)}    data-bs-dismiss="offcanvas" className="my-0 mx-3 text-1">Pricing</h5>,
        <h5 key="3" style={{cursor:"pointer"}} onClick={() => history.push("/contact-us")}           data-bs-dismiss="offcanvas" className="my-0 mx-3 text-1">Contact Us</h5>,
    ];

    // links for footer
    const footerLinks = [
        <h5 key="0" style={{cursor:"pointer"}} onClick={() => scrollToSection(howItWorksSectionRef)} className="my-3 text-inverse">How it Works</h5>,
        <h5 key="1" style={{cursor:"pointer"}} onClick={() => scrollToSection(companySectionRef)}    className="my-3 text-inverse">Company</h5>,
        <h5 key="2" style={{cursor:"pointer"}} onClick={() => scrollToSection(pricingSectionRef)}    className="my-3 text-inverse">Pricing</h5>,
        <h5 key="3" style={{cursor:"pointer"}} onClick={() => history.push("/contact-us")}           className="my-3 text-inverse">Contact Us</h5>,
    ];

    // action buttons for top navbar
    const navButtons = [
        <button style={{height:"3rem"}} onClick={() => scrollToSection(freeAlertsRef)} className="btn btn-outline-primary rounded-pill text-nowrap px-5 text-btn">Free Alerts</button>,
        <button style={{height:"3rem"}} onClick={()=>history.push(CHOOSE_PLAN_ROUTE)} className="btn btn-primary rounded-pill text-nowrap text-inverse px-5 text-btn">Get Started</button>
    ];

    // action buttons for sidebar
    const sidebarButtons = [
        <button style={{height:"3rem"}} onClick={() => scrollToSection(freeAlertsRef)} className="btn btn-outline-primary rounded-pill text-nowrap px-5 text-btn">Free Alerts</button>,
        <button style={{height:"3rem"}} onClick={()=>history.push(CHOOSE_PLAN_ROUTE)} className="btn btn-primary rounded-pill text-nowrap text-inverse px-5 text-btn">Get Started</button>
    ];

    return (
        <>
            <Navbar navHeight={navHeight} navButtons={navButtons} navLinks={navLinks} sidebarButtons={sidebarButtons} sidebarLinks={sidebarLinks} />
            <main className="w-100" style={{ marginTop: navHeight , overflowY : "hidden"}}>
                <IntroSection onSubscribe={() => scrollToSection(pricingSectionRef)} navHeight={navHeight}/>
                <HowItWorksSection anchor={howItWorksSectionRef} />
                <CompanySection anchor={companySectionRef} />
                <PricingSection history={history} anchor={pricingSectionRef} />
                <TestimonialSection />
                <FreeAlertsSection anchor={freeAlertsRef} />
            </main>
            <FooterSection history={history} links={footerLinks} />
        </>
    );
}
 
export default Home;